export class GcpMetricsSettingsInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudMonitoringEnabled",
            "baseName": "cloudMonitoringEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudMonitoringMetricPrefix",
            "baseName": "cloudMonitoringMetricPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpMetricsSettingsInput.attributeTypeMap;
    }
    constructor() {
    }
}
